import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 报表核对 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 下载月结账单 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 下载境内损益汇总 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _directive_active = _resolveDirective("active")!

  return (_openBlock(), _createBlock(_component_page_wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, { onRegister: _ctx.register }, {
        name: _withCtx(({ text, record }) => [
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToBill(record, true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]), [
            [_directive_active]
          ])
        ]),
        rd_state_name: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_state_color}`)
          }, _toDisplayString(text), 5)
        ]),
        finance_cut_money: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_cut_money_color}`)
          }, _toDisplayString(text), 5)
        ]),
        rd_bill_time_status: _withCtx(({ record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_bill_time_status_color}`)
          }, _toDisplayString(record.rd_bill_time_status), 5)
        ]),
        rd_pay_time_status: _withCtx(({ record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_pay_time_status_color}`)
          }, _toDisplayString(record.rd_pay_time_status), 5)
        ]),
        headerButton: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.filterType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
            options: _ctx.billDateRangeOptions,
            onChange: _ctx.reload,
            style: {"width":"240px !important"}
          }, null, 8, ["value", "options", "onChange"]),
          (_ctx.hasPermission('CanDownloadMonthlyBill'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadMonthlyBill('报表核对')))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasPermission('CanDownloadMonthlyBill'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadMonthlyBill('下载月结账单')))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.hasPermission('CanDownloadMonthlyBill'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadExportData()))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onRegister"])
    ]),
    _: 1
  }))
}